import { FETCH_ILETISIM_SUCCESS } from "../actions/iletisimAction";

const initState = {
    iletisim: [],
};

const iletisimReducer = (state = initState, action) => {
    if (action.type === FETCH_ILETISIM_SUCCESS) {
        return {
            ...state,
            iletisim: action.payload,
        };
    }

    return state;
};

export default iletisimReducer;
